export default __webpack_public_path__ + "static/media/main.f1624efc.svg";